import { useMemo } from 'react';
import DateUtils from '@zvuk-b2b/react-uikit/toolkit/DateUtils';
import { DeviceBindStatus } from 'application/presenters/point/types';
import AnalyticsService, {
  StreamBindFlowEventNameAMP,
  StreamBindFlowParamNameAMP,
} from 'application/services/AnalyticsService';
import { CompanyDeviceRequestPureType, DeviceTypes } from '@shared/api/graphql/generated';
import { PointParamNameAMP } from 'application/services/AnalyticsService/ampTypes';
import { CurrentPointOnboardingType, DeviceTypesInFlow } from '../types';

interface Props {
  point: CurrentPointOnboardingType;
  modalDeviceType: DeviceTypesInFlow;
  deviceRequests?: CompanyDeviceRequestPureType[] | null;
}

const useRequestDevicesController = ({ point, modalDeviceType, deviceRequests }: Props) => {
  const requestedDevices = useMemo(() => {
    const requestedDevicesMap = new Map<DeviceTypesInFlow, CompanyDeviceRequestPureType>();

    deviceRequests?.forEach((request) => {
      if (!request.pointId || !(request.pointId === point?.id)) {
        return;
      }

      if (!requestedDevicesMap.has(request.deviceType as unknown as DeviceTypesInFlow)) {
        requestedDevicesMap.set(request.deviceType as unknown as DeviceTypesInFlow, request);
      }
    });

    return requestedDevicesMap;
  }, [deviceRequests]);

  const onSuccessCallback = (deviceType: DeviceTypes) => {
    AnalyticsService.event(StreamBindFlowEventNameAMP.STREAM_PLAYER_TYPE_BOUND, {
      [StreamBindFlowParamNameAMP.PLAYER_TYPE]: deviceType,
      [PointParamNameAMP.POINT_ID]: point?.id,
    });
  };

  const requestedDevice = requestedDevices.get(modalDeviceType);

  const hasRecentRequest =
    requestedDevices && (requestedDevice?.deviceType as unknown as DeviceTypesInFlow) === modalDeviceType
      ? !DateUtils.isMoreThenDay(new Date(), new Date(requestedDevice?.lastRequestDate))
      : false;

  const alreadyBound = point?.device?.bindStatus === DeviceBindStatus.BINDED && point.device.type === modalDeviceType;
  const isFirstRequest = !(!!point?.device?.lastRequestTime && point.device.type === modalDeviceType);

  const hasThisDeviceType = point?.device?.actualType === modalDeviceType;
  const cantRequestDevice = hasThisDeviceType || alreadyBound;

  return {
    onSuccessCallback,
    hasRecentRequest,
    cantRequestDevice,
    isFirstRequest,
  };
};

export default useRequestDevicesController;
